// extracted by mini-css-extract-plugin
export default {"work":"work_work__y73Jx","label":"work_label__mgN4X","title":"work_title__2keCs","workRow":"work_workRow__kgnrM","workColumn":"work_workColumn__7RkSy"};